/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Canonical data source identifiers.
 * @export
 */
export const SourceId = {
  Openstreetmap: "openstreetmap",
  Openaddresses: "openaddresses",
  Whosonfirst: "whosonfirst",
  Geonames: "geonames",
  Foursquare: "foursquare",
} as const;
export type SourceId = (typeof SourceId)[keyof typeof SourceId];

export function instanceOfSourceId(value: any): boolean {
  for (const key in SourceId) {
    if (Object.prototype.hasOwnProperty.call(SourceId, key)) {
      if (SourceId[key as keyof typeof SourceId] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SourceIdFromJSON(json: any): SourceId {
  return SourceIdFromJSONTyped(json, false);
}

export function SourceIdFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SourceId {
  return json as SourceId;
}

export function SourceIdToJSON(value?: SourceId | null): any {
  return value as any;
}

export function SourceIdToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): SourceId {
  return value as SourceId;
}
